'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('./_tslib.js');
var React = require('react');
var experience_js = require('@ninetailed/experience.js');
var experience_jsReact = require('@ninetailed/experience.js-react');
var Tracker = require('./Tracker.js');
var loaders_ninetailedPlugins = require('./loaders/ninetailed-plugins.js');
require('@reach/router');
require('path');
require('crypto');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const createFunctionBody = serializedFunction => {
  return '"use strict";\n return ' + serializedFunction + ';';
};
const deserializeFunction = serializedFunction => {
  return new Function(createFunctionBody(serializedFunction))();
};
const deserializePluginOptionFunctions = options => {
  var _a;
  return (_a = options.serializedFunctionNames) === null || _a === void 0 ? void 0 : _a.reduce((acc, currFuncName) => {
    const currentFunction = options[currFuncName];
    if (currentFunction && typeof currentFunction === 'string') {
      return Object.assign(Object.assign({}, acc), {
        [currFuncName]: deserializeFunction(currentFunction)
      });
    }
    return acc;
  }, {});
};

let ninetailed;
const isSerializedPreviewPlugin = options => {
  return !!(options && options.customOptions && options.serializedFunctionNames && options.customOptions.serializedFunctionNames);
};
const WrapRootElement = ({
  children
}) => {
  const _a = deserializePluginOptionFunctions(loaders_ninetailedPlugins.options),
    {
      onRouteChange
    } = _a,
    functions = _tslib.__rest(_a, ["onRouteChange"]);
  if (!ninetailed) {
    const resolvedPlugins = loaders_ninetailedPlugins.plugins.map(({
      PluginCtor,
      options
    }) => {
      if (isSerializedPreviewPlugin(options)) {
        const updatedOptions = Object.assign(Object.assign(Object.assign({}, options), deserializePluginOptionFunctions(options)), {
          customOptions: Object.assign(Object.assign({}, options.customOptions), deserializePluginOptionFunctions(options.customOptions))
        });
        return new PluginCtor(updatedOptions);
      }
      if (options) {
        return new PluginCtor(options);
      }
      return new PluginCtor();
    });
    const {
      clientId,
      environment,
      preview,
      url,
      locale,
      requestTimeout,
      useSDKEvaluation
    } = loaders_ninetailedPlugins.options;
    ninetailed = new experience_js.Ninetailed({
      clientId,
      environment,
      preview
    }, Object.assign({
      url,
      plugins: resolvedPlugins,
      locale,
      requestTimeout,
      useSDKEvaluation
    }, functions));
  }
  return /*#__PURE__*/React__default["default"].createElement(experience_jsReact.NinetailedProvider, {
    ninetailed: ninetailed
  }, /*#__PURE__*/React__default["default"].createElement(Tracker.Tracker, {
    onRouteChange: onRouteChange
  }), children);
};
const wrapRootElement = (args, options) => {
  const {
    element
  } = args;
  return /*#__PURE__*/React__default["default"].createElement(WrapRootElement, Object.assign({}, options), element);
};

exports.wrapRootElement = wrapRootElement;
